import { useEffect } from 'react';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller';
import { useUserEmailDomain } from './context';

export type Config = {
	isSoftwareProjectType: boolean;
	isFreeEdition: boolean;
	userInEnglishLocale: boolean;
};

export const useGetUserEmailDomain = ({
	isSoftwareProjectType,
	isFreeEdition,
	userInEnglishLocale,
}: Config) => {
	const [{ loggedInEmailDomain }, { fetchUserEmailDomain }] = useUserEmailDomain();
	const isSiteAdmin = useIsSiteAdmin();

	useEffect(() => {
		if (
			userInEnglishLocale &&
			isSiteAdmin &&
			isSoftwareProjectType &&
			isFreeEdition &&
			!loggedInEmailDomain
		) {
			fetchUserEmailDomain();
		}
	}, [
		fetchUserEmailDomain,
		loggedInEmailDomain,
		isSiteAdmin,
		isSoftwareProjectType,
		isFreeEdition,
		userInEnglishLocale,
	]);

	return loggedInEmailDomain;
};
